import { reactive } from 'vue';
import { UserKeycloak, UserKeyCloakResponse } from '@shared/types/user';

const user: UserKeycloak = reactive({
	merchantCode: '',
	merchantName: '',
	merchantToken: '',
	divisionCode: '',
	sellerCode: '',
	sellerName: '',
	email: '',
	firstName: '',
	lastName: '',
	preferredName: '',
	isAuthenticated: false,
	hasAccessToHomepage: false, // Checked against merchantCode TODO: remove when bookkeeping 2.0 is live
});

const verifyUserAttributes = (userInfo: UserKeyCloakResponse): boolean => {
	return (
		!!userInfo.merchantCode &&
		!!userInfo.merchantToken &&
		!!userInfo.merchantName &&
		!!userInfo.divisionCode
	);
};

const setUserInfo = (
	userInfo: UserKeyCloakResponse,
	isAuthenticated: boolean,
	hasAccessToHomepage: boolean
): void => {
	user.merchantName = userInfo.merchantName || '';
	user.merchantCode = userInfo.merchantCode || '';
	user.merchantToken = userInfo.merchantToken || '';
	user.divisionCode = userInfo.divisionCode || '';
	user.sellerName = userInfo.sellerName || '';
	user.sellerCode = userInfo.sellerCode || '';
	user.email = userInfo.email || '';
	user.firstName = userInfo.given_name || '';
	user.lastName = userInfo.family_name || '';
	user.isAuthenticated = isAuthenticated || false;
	user.preferredName = userInfo.preferred_username || '';
	user.hasAccessToHomepage = hasAccessToHomepage || false;
};

export default function UsersStore() {
	return {
		user,
		verifyUserAttributes,
		setUserInfo,
	};
}
